/**
 * One-time notices (Sparky's banners).
 *
 * "Dismissed" used to live in component state, so every banner came back on the next page load —
 * which is the opposite of what "Got it" means. Dismissals are keyed per project AND per moment, so
 * closing "It is live" on one project does not silence it on a project you have never published.
 */
const KEY = 'cbx.notices';

function read(): string[] {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) ?? '[]') as unknown;
    return Array.isArray(raw) ? raw.filter((v): v is string => typeof v === 'string') : [];
  } catch {
    return []; // corrupt storage must never break the studio — worst case a banner shows again
  }
}

export function isNoticeDismissed(id: string): boolean {
  return read().includes(id);
}

export function dismissNotice(id: string): void {
  const all = read();
  if (all.includes(id)) return;
  try {
    localStorage.setItem(KEY, JSON.stringify([...all, id].slice(-200)));
  } catch {
    /* private mode / quota — the banner simply reappears next session */
  }
}
